import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { PopupButton, Widget } from "@typeform/embed-react"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import { getClientId, gtmSubmit } from "@/utils/gtm-tracking"
import { getClientIdFromGaCookie } from "@/utils/cookie-detection"

const getInitialPathname = () =>
  typeof window !== "undefined" ? window.location.pathname : null
const getInitialClientId = () =>
  typeof window !== "undefined" ? (getClientIdFromGaCookie() ?? null) : null

const TypeformQuiz = ({
  title,
  selectedQuizId,
  popup = false,
  onEndingButtonClicked,
  triggerButtonClassName,
  size = 70,
}) => {
  const { t } = useTranslation()
  const [clientId, setClientId] = useState(getInitialClientId)
  const [pathname] = useState(getInitialPathname)

  const popupEmbedRef = useRef()

  useEffect(() => {
    if (clientId === null) {
      getClientId(setClientId)
    }
  }, [clientId])

  const hidden = useMemo(
    () => ({
      user_id: clientId ?? "",
      page_path: pathname ?? "",
    }),
    [clientId, pathname],
  )

  const onSubmit = useCallback(() => {
    gtmSubmit("Typeform Quiz Submission", title)()
  }, [title])

  const handleEndingButtonClick = useCallback(
    event => {
      popupEmbedRef.current?.close?.()
      onEndingButtonClicked?.(event)
    },
    [onEndingButtonClicked],
  )

  if (!selectedQuizId) {
    return null
  }

  const wrapperClass = `typeform-quiz ${popup ? "typeform-quiz__popup" : ""}`

  if (popup) {
    return (
      <div className={wrapperClass}>
        <PopupButton
          as="button"
          buttonProps={{ className: triggerButtonClassName }}
          id={selectedQuizId}
          hidden={hidden}
          embedRef={popupEmbedRef}
          onSubmit={onSubmit}
          onEndingButtonClick={handleEndingButtonClick}
          size={size}
        >
          {t("plans.help-me-choose")}
        </PopupButton>
      </div>
    )
  }

  return (
    <div className={wrapperClass}>
      <Widget
        id={selectedQuizId}
        hidden={hidden}
        onSubmit={onSubmit}
        onEndingButtonClick={handleEndingButtonClick}
        style={{ width: "100%", minHeight: 400 }}
      />
    </div>
  )
}

export default TypeformQuiz
